import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InitialService {
  private static scriptLoaded = false;
  private static loadPromise: Promise<void> | null = null;

  async setUpGoogleScript(): Promise<void> {
    if (InitialService.loadPromise) {
      return InitialService.loadPromise;
    }

    const SCRIPT_ID = 'google-maps-script';

    if (document.getElementById(SCRIPT_ID)) {
      InitialService.scriptLoaded = true;
      return Promise.resolve();
    }

    InitialService.loadPromise = new Promise<void>(resolve => {
      const script = document.createElement('script');
      script.id = SCRIPT_ID;
      script.type = 'text/javascript';
      script.async = true;
      script.defer = true;
      script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleKey}&libraries=places,drawing,geometry,visualization&language=en`;
      script.onload = (): void => {
        InitialService.scriptLoaded = true;
        resolve();
      };
      script.onerror = (): void => {
        console.error('Google Maps script failed to load.');
        resolve();
      };
      document.body.appendChild(script);
    });

    return InitialService.loadPromise;
  }

  static isLoaded(): boolean {
    return InitialService.scriptLoaded;
  }
}
